export default "__VITE_ASSET__BOWQhUbc__"